var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilterIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M15.5.334v1.667h-.833L10.5 8.25v7.083h-5V8.251L1.333 2H.5V.334zM3.337 2.001l3.83 5.745v5.921h1.666V7.746L12.663 2z"
})));
export { SvgFilterIcon as ReactComponent };
export default __webpack_public_path__ + "6ab2de320856d9ffc8b0f3b907b5892e.svg";